<div class="mt-3 mb-3">
  <a id="{{aPanelData.name}}"></a><h1 *ngIf="'' != aPanelData.title" class="display-1 text-uppercase" [innerHTML]="app.bypassHtmlSanitizing(aPanelData.title)"></h1>
  <div [ngSwitch]="aPanelData.type">
    <div *ngSwitchCase="'block'">
      <div [innerHTML]="app.bypassHtmlSanitizing(aPanelData.content)"></div>
    </div>
    <div *ngSwitchDefault>
      <manager-wgt [aWidgetParams]="aPanelData"></manager-wgt>
    </div>
  </div>
</div>